import './App.css';
import SignDemo from './components/SignDemo';

function App() {
  return <SignDemo />;
}

export default App;
